export const IDENTIFY_FO_APP = (self, identifier, data) => {
    if (self.$hj) {
        data.app = 'FO_APP';
        self.$hj('identify', identifier, data)
    }
}

export const IDENTIFY_LSP_APP = (self, identifier, data) => {
    if (self.$hj) {
        data.app = 'LSP_APP';
        self.$hj('identify', identifier, data)
    }
}
